<template>
    <div class="dap-multi-cascader-wrapper">
        <div class="search-block m-b-10" v-if="filterable" v-on-clickaway="handleAway">
            <el-input
                style="width: 100%" size="small"
                v-model="search" :placeholder="searchPlaceholder"
                class="input-with-select search-input"
                @keyup.enter.native="handleSearch">
                <el-button slot="append" type="mini" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
            <div class="search-body" v-show="isShowSearchList">
                <div v-if="searchLoading" class="f12 c-999 flex-center">搜索中</div>
                <div v-else>
                    <div v-for="item in searchList" :key="item[propsMapper.value]">
                        <slot name="searchItem" :item="item">
                            <div class="hand f12 flex-between-center search-item" @click="chooseSearch(item)">
                                <span class="">{{item.searchName || item.name}}</span>
                                <span class="">{{item.num}}</span>
                            </div>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="cascader-content">
            <div class="cascader-left">
                <slot name="checkAll">
                    <div class="cascader-title flex-normal p-l-20 f12">
                        <div class="checkStateBox flex-center" @click="handleChangeCheckState">
                            <DapIconSvg class="f18 hand"
                                        :class="checkState > 0 ? 'c-blue' : ''"
                                        :iconClass="checkState === 2 ? 'duoxuanxuanzhong' :
                            checkState === 0 ? 'duoxuanweixuan' : 'duoxuanweiquanxuan'" />
                        </div>
                        <div class="m-l-10 flex-center hand c-666" @click="handleChangeCheckState">
                            全选
                            <slot name="select-all-tip" />
                        </div>

                    </div>
                </slot>
                <div class="cascader-body-wrapper">
                    <div class="cascader-body box-sizing" ref="cascaderBody">
                        <el-cascader-panel
                            ref="cascader"
                            v-model="checkedIdList" :options="processedDataList" :props="defaultProps"
                            :show-all-levels="false"
                            @change="emitResult" @expand-change="handleExpandChange">
                            <template v-slot:default="item">
                                <slot name="default" :item="item">
                                    <span v-if="!item.data.tip">{{ item.data.name }}</span>
                                    <el-tooltip :content="item.data.tip" placement="bottom" v-else>
                                        <span>{{ item.data.name }}</span>
                                    </el-tooltip>
                                </slot>
                            </template>
                        </el-cascader-panel>
                    </div>
                </div>
            </div>

            <div class="area-right m-l-10" v-if="showResult">
                <div class="title-body">
                    <slot name="right-title">
                        <span class="f12 c-666">已选</span>
                    </slot>
                    <el-button type="text" class="f12" @click="clearAll">清空全部</el-button>
                </div>
                <div class="item-body">
                    <div class="item m-t-10 m-b-10 flex-normal" v-for="(item, index) in resultList" :key="index">
                        <div style="flex: auto" class="item-title ">
                            <slot name="result" v-bind="item">
                                <div class="text-ellipsis" :title="item.name">{{item.name}}</div>
                            </slot>
                        </div>
                        <div style="flex: none" >
                            <i class="el-icon-close c-ccc hand f14" @click="handleRemoveItem(item)"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import {directive as onClickaway} from 'vue-clickaway';

export default {
    name: 'DapMultiCascader',

    directives: {
        onClickaway: onClickaway,
    },
    provide () {
        return {
            elForm: '',
            elFormItem: '',
        };
    },

    props: {
        title: {
            type: String,
            default: '全部'
        },
        dataList: {
            type: Array,
            default: () => []
        },
        resultList: {
            type: Array,
            default: () => []
        },
        initResultList: Array,
        propsMapper: {
            type: Object,
            default: () => ({ value: 'id', label: 'name' }),
        },
        searchFunc: Function,
        filterable: {
            type: Boolean,
            default: false
        },
        showResult: {
            type: Boolean,
            default: true
        },
        isTogether: {
            type: Boolean,
            default: true
        },
        // 将指定的选项置灰，不可选
        disabledList: {
            type: Array,
            // id list [1,2,3,4]
            default: () => []
        },
        searchPlaceholder: {
            type: String,
            default: '请输入名称'
        },
        // 搜索时下拉的分隔符
        separator: {
            type: String,
            default: '/'
        }
    },

    data () {
        return {
            search: '',
            selfResultList: [],
            checkedIdList: [],
            searchList: [],
            inputList: [],
            isShowSearchList: false,
            searchLoading: false,
        };
    },
    computed: {
        defaultProps () {
            return {
                multiple: true,
                emitPath: false,
                ...this.propsMapper,
            };
        },
        childrenIdList () {
            const dataList = this.dataList;
            return this.getCurrentLayerChildrenIds(dataList);
        },
        checkState () {
            const length = this.checkedIdList.length
            if (length === 0) {
                return 0;
            }
            if (length === this.childrenIdList.length) {
                return 2;
            }
            return 1;
        },
        processedDataList () {
            const dataList = JSON.parse(JSON.stringify(this.dataList));
            this.removeEmptyChildren(dataList);
            return dataList;
        },
        // 生成用于搜索的扁平dataList
        plainDataList () {
            return this.getPlainDataList(this.processedDataList, '')
        },
    },

    methods: {
        handleExpandChange (val) {
            if (val.length >= 2) {
                setTimeout(() => {
                    const element = this.$refs.cascaderBody;
                    element.scrollLeft += 180;
                }, 0);
            }
        },

        emitResult () {
            this.$nextTick(() => {
                if (this.isTogether) {
                    this.$emit('change', this.getTogetherResultList());
                } else {
                    const result = this.$refs.cascader.getCheckedNodes(true);
                    this.$emit('change', result.map(i => i.data));
                }
            });
        },

        clearAll () {
            this.checkedIdList = [];
            this.$emit('change', []);
        },

        // 递归生成用于搜索的扁平dataList
        getPlainDataList (layerList, preName = '') {
            return layerList.reduce((res, item) => {
                const name = preName
                    ? `${preName} ${this.separator} ${item[this.propsMapper.label]}`
                    : item[this.propsMapper.label];
                if (!item.children) {
                    return [...res, {
                        ...item,
                        searchName: name
                    }]
                } else {
                    return [
                        ...res, {
                            ...item,
                            searchName: name
                        },
                        ...this.getPlainDataList(item.children, name)
                    ]
                }
            }, []);
        },

        // 找到这一层下面所有的可用的id
        getCurrentLayerChildrenIds (layer) {
            return layer.reduce((res, item) => {
                if (item.disabled) {
                    return res;
                }
                if (item.children && item.children.length > 0) {
                    return [...res, ...this.getCurrentLayerChildrenIds(item.children)];
                }
                return [...res, item[this.propsMapper.value]];
            }, []);
        },

        handleRemoveItem (item) {
            const deleteLayer = this.getLayerById(this.dataList, item[this.propsMapper.value]);
            if (deleteLayer) {
                const deleteIds = this.getCurrentLayerChildrenIds([deleteLayer]);
                this.checkedIdList = this.checkedIdList.filter(i => !deleteIds.includes(i));
                this.emitResult();
            }
        },

        // 根据id,从layer中找到这一层.
        getLayerById (layer, id) {
            const res = layer.map(item => {
                if (item[this.propsMapper.value] === id) {
                    return item;
                }
                if (item.children && item.children.length > 0) {
                    return this.getLayerById(item.children, id);
                }
                return false;
            }).filter(i => i);
            return res.length > 0 ? res[0] : false;
        },

        // 找到idList里面每个id所在层的最内层叶子节点的集合
        getInnerIds (idList) {
            return idList.reduce((res, item) => {
                const layer = this.getLayerById(this.dataList, item);
                if (layer) {
                    return [...res, ...this.getCurrentLayerChildrenIds([layer])];
                }
                return res;
            }, []);
        },

        getTogetherResultList () {
            const result = this.$refs.cascader.getCheckedNodes();
            // 遍历一遍result, 获取所有需要删除的values
            const deleteIds = result.reduce((res, item) => {
                if (item.children) {
                    return [...res, ...item.children.map(i => i.value)];
                }
                return res;
            }, []);
            return result.filter(i => !deleteIds.includes(i.value)).map(i => i.data);
        },

        handleChangeCheckState () {
            if (this.checkState === 2) {
                this.checkedIdList = [];
            } else {
                this.checkedIdList = this.childrenIdList;
            }
            this.$nextTick(() => {
                this.emitResult();
            });
        },

        removeEmptyChildren (dataList) {
            dataList.forEach(item => {
                if (item.children) {
                    if (item.children.length === 0) {
                        delete item.children;
                        return;
                    }
                    this.removeEmptyChildren(item.children);
                }
            })
        },

        handleSearch () {
            this.searchList = [];
            if (this.searchFunc) {
                this.searchLoading = true;
                this.searchFunc(this.search).then(res => {
                    this.searchLoading = false;
                    if (Array.isArray(res)) {
                        this.searchList = res;
                        this.isShowSearchList = !this.isShowSearchList;
                    }
                })
            } else {
                this.searchList = this.plainDataList.filter(
                    i => i.searchName.toLowerCase().includes(this.search.toLowerCase())
                );
                this.isShowSearchList = !this.isShowSearchList;
            }
        },

        chooseSearch (res) {
            if (this.$listeners.chooseSearch) {
                this.$emit('chooseSearch', res);
            } else {
                const newRes = [
                    ...this.resultList,
                    res
                ].map(i => i[this.propsMapper.value]);
                this.checkedIdList = this.getInnerIds(newRes);
                this.$nextTick(() => {
                    this.emitResult();
                });
            }
            this.search = '';
            this.isShowSearchList = false;
        },

        handleAway () {
            this.isShowSearchList = false;
        },
    },

    watch: {
        // dataList: {
        //     handler (val) {
        //         if (val) {
        //             this.removeEmptyChildren(val);
        //         }
        //     },
        //     immediate: true,
        // },
        initResultList: {
            handler (val) {
                if (val) {
                    this.checkedIdList = this.getInnerIds(val);
                    this.$nextTick(() => {
                        this.emitResult();
                    });
                }
            },
            immediate: true,
        },

    }

};
</script>

<style lang="scss">
.dap-multi-cascader-wrapper {
    display: inline-block;
    .el-cascader-panel.is-bordered {
        border: none;
        .el-cascader-menu {
            border-right: none;
            .el-cascader-menu__wrap {
                height: 300px;
                .el-cascader-menu__list {
                    width: 180px;
                    border-right: 1px solid #E9E9EB;
                    box-sizing: border-box;
                }
            }
        }
    }
    .search-block {
        position: relative;
        .el-input-group__append {
            width: 30px;
            text-align: center;
            background-color: #fff;
            padding: 0;
        }
        .search-body {
            position: absolute;
            width: 100%;
            height: 340px;
            margin-top: 10px;
            z-index: 999;
            overflow-y: auto;
            background: #fff;
            border-radius: 4px;
            border: 1px solid #E9E9EB;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
            .search-item {
                padding: 2px 10px;
                &:hover {
                    background-color: #F5F7FA;
                }
            }
        }
    }

    .cascader-content {
        display: flex;
    }

    .cascader-left {
        .cascader-title {
            height: 39px;
            color: #606266;
            background: #F8F8F8;
            border: solid 1px #E9E9EB;
            border-bottom: 0;
        }

        .cascader-body {
            white-space: nowrap;
            width: 539px;
            border: 1px solid #E9E9EB;
            overflow-x: auto;
        }
    }

    .area-right {
        width: 250px;
        .title-body {
            padding: 0 20px;
            display: flex;
            height: 39px;
            justify-content: space-between;
            align-items: center;
            background: #F8F8F8;
            border: 1px solid #E9E9EB;

        }
        .item-body {
            height: 292px;
            margin: 0;
            padding: 0 10px;
            overflow-y: auto;
            border: 1px solid #E9E9EB;
            border-top: 0;
            box-sizing: border-box;

            .item {
                background: #F4F4F5;
                line-height: 17px;
                font-size: 12px;
                position: relative;
                padding: 10px;
                box-sizing: border-box;
                width: 100%;
                .item-title {
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>
